export enum WatchlistElementObjectType {
  Product = 'Product',
  Supplier = 'Supplier',
  Query = 'Query',
  Comparison = 'Comparison',
  ProductValidation = 'ProductValidation',
  ProductSpecification = 'Productspecification'
}
